import type { ReactNode } from 'react';

// 設定画面の共通モーダル（teams-page の見た目を踏襲）。
// オーバーレイクリックで閉じる・中身クリックは透過しない・ヘッダに閉じる✕。
export function Modal({
  title,
  onClose,
  children,
  width = 480,
}: {
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  width?: number;
}) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,0.45)',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '7vh 16px',
        zIndex: 50,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="k-card"
        style={{ width: '100%', maxWidth: width, maxHeight: '85vh', overflow: 'auto' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 14,
          }}
        >
          <h3 style={{ margin: 0 }}>{title}</h3>
          <button className="btn-ghost" type="button" onClick={onClose} aria-label="閉じる">
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
